class AliquotaController extends AbstractController
  @$inject = [ '$injector', '$scope', 'pathService', 'estadoService', 'aliquotaService' ]

  constructor: ($injector, @scope, pathService, @estadoService, @aliquotaService) ->
    super($injector)

    @loadingTracker = @promiseTracker()
    url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/aliquota-estadual-especifica/"
    @modalAliquota = @openPopup(url + "modal/modal.html", 'aliquotaModalController as ctrl')
    @modalAliquotaImportar = @openPopup(url + "importar.html", 'aliquotaImportarController as ctrl')

    @filtro =
      page: 1
      estado: ''

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @listOfAliquota = []
    @listOfEstado = []

    @loadingTracker.addPromise @estadoService.getList(
      (data) => @listOfEstado = data
    )

    @loadData()

  loadData: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    @loadingTracker.addPromise @aliquotaService.getList(filtro, (result) =>
      if result.success
        @listOfAliquota = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar lista de alíquotas.', 'Erro!', false)
    )

  importar: ->
    @modalAliquotaImportar({}, (result) =>
      if result.ok
        @listOfAliquota = result.data.items

        @pagination =
          page: @filtro.page
          totalPages: result.data.totalPages
          perPage: 1
    )

  adicionar: (aliquota)->
    @modalAliquota({
        aliquota: -> if aliquota? then aliquota else {}
        listOfEstado: => @listOfEstado
      }, (result) =>
      if result.ok
        @listOfAliquota.push(result.data)
    )

  editar: (aliquota) ->
    @modalAliquota({
        aliquota: -> aliquota
        listOfEstado: => @listOfEstado
      }, (result) =>
      if result.ok
        aliquota = result.data

        index = @listOfAliquota.getIndex(aliquota.id, 'id')
        @listOfAliquota[index] = aliquota
    )

  remover: (aliquota) ->
    Confirm.warning("Atenção", "Deseja realmente remover a alíquota estadual Nº <strong>#{aliquota.id}</strong>? Esta ação <strong>não poderá</strong> ser desfeita.", {
        "Não": null
        "Sim": =>
          @aliquotaService.delete(aliquota.id, (data) =>
            Alert.success("Alíquota estadual Nº <strong>#{aliquota.id}</strong> removida com sucesso.", 'Sucesso!')
            @listOfAliquota.remove(@listOfAliquota.getIndex(aliquota.id, 'id'))
          )
      }
    )

  clonar: (aliquota) ->
    copia = angular.copy aliquota
    copia.id = null
    copia.aliquotasEspeciais = []
    @adicionar(copia)

class AliquotaModalController extends AbstractController
  @$inject = [ '$injector', 'aliquotaService', '$uibModalInstance', 'listOfEstado', 'aliquota' ]

  constructor: ($injector, @aliquotaService, @modalInstance, @listOfEstado, aliquota) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @aliquota = angular.copy aliquota

    @aliquota.aliquotasEspeciais = [] if @aliquota.aliquotasEspeciais == undefined
    @aliquotaEspecial = {}
    @aliquota.aliquota ?= 0
    @aliquota.observacoes ?= []
    @aliquota.vigenciaInicio ?= ''
    @aliquota.vigenciaFim ?= ''

  addAliquotaEspecial: ->
    @aliquota.aliquotasEspeciais.push @aliquotaEspecial
    @aliquotaEspecial = {}

  removerAliquotaEspecial: (index)->
    if(index > -1)
      @aliquota.aliquotasEspeciais.splice(index, 1)

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @aliquotaService.save(@aliquota, (data) =>
        Alert.success("Alíquota estadual Nº  <strong>#{data.id}</strong> #{if @aliquota.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )

class AliquotaImportarController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'FileUploader', 'aliquotaService' ]

  constructor: ($injector, @modalInstance, FileUploader, @aliquotaService) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @uploader = new FileUploader(
      url: "/api/eficiencia-fiscal/aliquota-icms"
      headers: cbk.getHeaders()
      filters: [ {
        name: 'extFilter'
        fn: (item, options) =>
          extension = item.type == 'text/csv' || item.type == "application/vnd.ms-excel"
          @extension = !extension
          @uploader.clearQueue() unless extension
          document.getElementById('file').value = '' unless extension

          return extension
      } ]
      onBeforeUploadItem: (item) =>
        item.formData = [ {
          contrato: @contrato
        } ]
    )

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      if response.success
        @Alert.success('O CSV de alíquotas estaduais específicas foi importado com sucesso.', 'Sucesso')
        @modalInstance.close(new Retorno(response.success, null, response.data))
      else
        if response.message == 'ncm_em_branco'
          @Alert.warning('Arquivo importado possui NCM em branco. Verifique e tente novamente.', 'Operação não realizada', false)
        else
          @Alert.warning('Ocorreu um erro ao realizar a importação.', 'Operação não realizada', false)

  importar: () ->
    @uploader.uploadAll()

  baixar: () ->
    cbk.download '/api/eficiencia-fiscal/aliquota-icms.csv'

angular.module('eficienciaFiscalModule').controller('aliquotaController', AliquotaController)
angular.module('eficienciaFiscalModule').controller('aliquotaModalController', AliquotaModalController)
angular.module('eficienciaFiscalModule').controller('aliquotaImportarController', AliquotaImportarController)